import { useEffect } from "react";
import _ from "lodash";

import PusherManager from "utils/pusher-manager";

import { useSignedUser } from "entities/Auth/sdk";

export const useReportPackageDetailsInvalidateSucceeded = ({
  eventHandler,
}: {
  eventHandler: ({
    reportPackageId,
    reportPackageName,
  }: {
    reportPackageId: number;
    reportPackageName: string;
  }) => void;
}) => {
  const { data: user } = useSignedUser();

  useEffect(() => {
    if (!_.isUndefined(user)) {
      return PusherManager.bindToReportPackageDetailsInvalidateSucceededEvent({
        userId: user.id,
        eventHandler: ({
          report_package_id: reportPackageId,
          report_package_name: reportPackageName,
        }: {
          report_package_id: number;
          report_package_name: string;
        }) => eventHandler({ reportPackageId, reportPackageName }),
      });
    }
  }, [user, eventHandler]);
};
